import axios from "axios";
import { ThreeKitApi, ThreeKitToken as token, restApi } from "../utils/constants";
import { createSnapshot } from '../utils/playcanvasChange';

function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

export const SavedConfiguration = async ({ metadata, orgId }) => {
  const snapshot = await createSnapshot();
  if (!snapshot) return [undefined, { message: "Snapshot failed" }];

  const blob = dataURItoBlob(snapshot);
  const file = new File([blob], "snapshot.png");

  const config = window.configurator?.getConfig?.() || {};

  const fd = new FormData();
  fd.append("files", file);
  fd.append("productVersion", "v1");
  fd.append("orgId", orgId);
  fd.append("variant", JSON.stringify(config));
  if (metadata && Object.keys(metadata).length) {
    fd.append("metadata", JSON.stringify(metadata));
  }

  const response = await fetch(
    `${ThreeKitApi}/configurations?bearer_token=${token}`,
    { method: "post", body: fd }
  );

  return response.json();
};

export const getSavedConfiguration = async ({ ...props }) => {
  const { configurationId } = props;

  let error;
  if (!configurationId) error = "Requires Configuration ID";
  if (error) return [undefined, { message: error }];

  let { data } = await axios.get(
    `${ThreeKitApi}/configurations/${configurationId}?bearer_token=${token}`
  );
  return data;
};

export const sendFormToRest = async (body) => {
    
  const { data: {pdfName} } = await axios.post(`${restApi}/request`, {...body});


  return pdfName;
}

export const getIpAddress = async () => {
  const { data: {ip} } = await axios.get('https://api.ipify.org/?format=json')

  return ip
}

export const downloadPdf = async (name) => {
  axios({
    method: 'GET',
    url: `${restApi}/pdf/${name}`,
    responseType: 'blob'
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${name}.pdf`);
    document.body.appendChild(link);
    link.click();
  })
  
}